
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freecreditevaluation",
      function () {
        return require("private-next-pages/freecreditevaluation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freecreditevaluation"])
      });
    }
  